export default function leadershipSlider() {
  if (document.querySelector(".swiper-leadership_slider")) {
    let leadership = new Swiper(".swiper-leadership_slider", {
      slidesPerView: 1,
      loop: false,
      speed: 1500,
      allowTouchMove: true,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-btn-prev",
        prevEl: ".swiper-btn-next",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        720: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        996: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  }
}
